import { FormControl, Stack, Spinner, RadioGroup, Radio, FormErrorMessage, Text, Box } from '@chakra-ui/react'
import { useFormContext, Controller } from 'react-hook-form'

import { FormLabel } from '../../components/FormLabel'
import { RadioStack } from '../../components/RadioStack'

import { SelectionType } from 'brokertslib/src/enums'
import { useSelections } from '../../hooks'
import { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos/Travel'


export const TripType = ({ isContracted }: { isContracted: boolean }) => {
  const { control, formState: { errors } } = useFormContext<InsuranceParamsTravelDto>()

  const { data: dataReason, isLoading: isLoadingReason, isFetching: isFetchingReason } = useSelections(SelectionType.TravelReason)

  return (
    <FormControl isInvalid={!!errors.travel?.reason} isRequired>
      <Stack direction={'row'}>
        <FormLabel
          tooltip={
            <Box>
              <strong>POBYTOVÁ CESTA</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem odpočinkové a rekreační turistiky, studijní pobyt a stáž, pobyty au pair, brigády studentů.</Text><br />
              <strong>POZNÁVACÍ CESTA</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem odpočinkové, rekreační turistiky nebo rekreačních sportů.</Text><br />
              <strong>PRACOVNÍ CESTA</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem plnění pracovních úkolů nebo v přímé souvislosti s plněním těchto pracovních úkolů zaměstnance vyslaného zaměstnavatelem, fyzické osoby nebo podnikatele (např. administrativní činnosti).</Text><br />
              <strong>PRACOVNÍ CESTA (manuální)</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem plnění pracovních úkolů nebo v přímé souvislosti s plněním těchto pracovních úkolů zaměstnance vyslaného zaměstnavatelem, fyzické osoby nebo podnikatele (např. zednické práce).</Text>
            </Box>
          }>
          Důvod cesty
        </FormLabel>
        {(isFetchingReason || isLoadingReason) && <Spinner />}
      </Stack>
      <Controller
        name="travel.reason"
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup onChange={e => onChange(parseInt(e))} value={value?.toString() ?? ''} isDisabled={isContracted}>
            <RadioStack variant="stackedTile">
              {dataReason?.data.map((item) => (
                <Radio value={item.id.toString()} key={item.id}>
                  {item.description}
                </Radio>
              ))}
            </RadioStack>
          </RadioGroup>
        )}
      />
      {errors.travel?.reason && <FormErrorMessage>{errors.travel.reason.message}</FormErrorMessage>}
    </FormControl>
  )
}
